import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reservations-schedule"
export default class extends Controller {
  static targets = ["startTime", "endTime"]

  connect() {
  }
}
